// extracted by mini-css-extract-plugin
export default {"pedido-status-layout-container":"PedidoStatusLayout_pedido-status-layout-container__IUYot","pedido-status-layout":"PedidoStatusLayout_pedido-status-layout__HfPd2"};